export enum CallStateEnum {
    CONNECTING = 'CONNECTING',
    GROUP_CALL = 'GROUP_CALL',
    IDLE = 'IDLE',
    IN_CALL = 'IN_CALL',
}
